/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-on-hold',
  templateUrl: './on-hold.component.html'
})
export class OnHoldComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
